import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {HTMLContent, contentUtils} from "mindsets-js-sdk";

class Table extends Component {
    getHTML() {
        return this.props.component_data.data.html
    }

    getContent() {
        return (
            <HTMLContent
                className='d-flex justify-content-start'
                html_str={contentUtils.processStringContent(this.getHTML(), {
                    keep_html: true,
                    convert_math: true,
                    convert_spelling: false,
                })}/>
        );
    }

    render() {
        return (
            <div className="challenge-component-table">
                <div className="horizontal-scroll-container">
                    {this.getContent()}
                </div>
            </div>
        )
    }
}

Table.propTypes = {
    component_data: PropTypes.object.isRequired
}

export default Table
